import { useRef, useState } from 'react'

import { useScrollIntoView } from '../../../../../hooks'
import { getQaSelector } from '../../../../../utils/common'
import { stopPropagation } from '../../../../../utils/events'
import { AccordionAnimatedContent } from '../../../../Accordion'
import { FormFieldsContainer } from '../../../../Form'
import {
  BUILDING_FORM_INSURANCE_FIELD_NAME_CONTRACT_NUMBER,
  BUILDING_FORM_INSURANCE_FIELD_NAME_INSURANCE_TYPE,
  BUILDING_FORM_INSURANCE_FIELD_NAME_SUPPLIER,
} from '../../BuildingForm.constants'
import { AccordionControlButtons } from '../AccordionControlButtons'
import { getBuildingFormInsuranceFieldName } from '../BuildingFormInsuranceFields.utils'
import { ContractNumberField } from '../ContractNumberField'
import { InsuranceTypeField } from '../InsuranceTypeField'
import { SupplierField } from '../SupplierField'

import { QA_INSURANCE_CONTEXT } from './Fields.constants'

import * as styles from './Fields.module.css'

function Fields({ className = styles.Fields, index, onRemove }) {
  const [isOpen, setOpen] = useState(true)

  const contentRef = useRef(null)

  const { ref: formRef } = useScrollIntoView({ dependency: isOpen })

  function handleToggleVisibility() {
    setOpen(prevVisibility => !prevVisibility)
  }

  function handleRemove(event) {
    stopPropagation(event)

    onRemove(index)
  }

  function scrollIntoView() {
    contentRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' })
  }

  const qaProps = getQaSelector({
    context: QA_INSURANCE_CONTEXT,
    value: index + 1,
  })

  return (
    <div {...qaProps} className={className} ref={formRef}>
      <AccordionControlButtons
        index={index}
        isOpen={isOpen}
        onRemove={handleRemove}
        onToggleVisibility={handleToggleVisibility}
      />
      <AccordionAnimatedContent
        isOpen={isOpen}
        ref={contentRef}
        onTransitionEnd={scrollIntoView}
      >
        <FormFieldsContainer className={styles.fieldsContainer}>
          <InsuranceTypeField
            name={getBuildingFormInsuranceFieldName({
              index,
              name: BUILDING_FORM_INSURANCE_FIELD_NAME_INSURANCE_TYPE,
            })}
          />
          <ContractNumberField
            name={getBuildingFormInsuranceFieldName({
              index,
              name: BUILDING_FORM_INSURANCE_FIELD_NAME_CONTRACT_NUMBER,
            })}
          />
          <SupplierField
            name={getBuildingFormInsuranceFieldName({
              index,
              name: BUILDING_FORM_INSURANCE_FIELD_NAME_SUPPLIER,
            })}
          />
        </FormFieldsContainer>
      </AccordionAnimatedContent>
    </div>
  )
}

export default Fields
